export default "__VITE_ASSET__DhnMt4AI__"